import React from "react";

import { useGetFarms } from "utils";

import { HideFeature } from "components";

export const HideFCPOFeatureForUnenrolledFarms = ({ children }: { children: React.ReactElement | null }) => {
  const { currentFarm } = useGetFarms();

  const farmIsEnrolledInCarbonProgram = !!currentFarm?.carbonProgram?.id;

  return (
    <>
      <HideFeature hide={!farmIsEnrolledInCarbonProgram} fallback={null}>
        {children}
      </HideFeature>
    </>
  );
};
